/* jshint esversion: 6 */
/* jshint ignore:start */
import Header from './Component/Header';
import './App.css';
import './index.css';
import './Style/style.css';
import './Style/Responsive.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer } from 'react-toastify';
import Footer from './Component/Footer';
import { Routes, Route, useLocation } from 'react-router-dom';
import EventDetails from './Component/UserComponent/EventDetails';
import Dashboard from './Component/UserComponent/Dashboard';
import EventCategory from './Component/UserComponent/EventCategory';
import OrderSummery from './Component/UserComponent/OrderSummery';
import Booking from './Component/UserComponent/Booking';
import Ticket from './Component/UserComponent/Ticket';
import Favorite from './Component/UserComponent/Favorite';
import Wallet from './Component/UserComponent/Wallet';
import Success, { Cancel } from './Component/Payment/Success';
import PaymentResponse from './Component/Payment/PaymentResponse';
import Profile from './Component/UserComponent/Profile';
import Chat from './Component/UserComponent/Chat';
import Faq from './Component/Faq';
import Pages from './Component/Pages';
import Organizer from './Component/UserComponent/Organizer';

function App() {

  const location = useLocation();
  const Hidden = location.pathname.startsWith("/chat");

  return (
    <>
      <Header />
      <Routes>

        <Route path="/" element={<Dashboard />} />
        <Route path="/event-details" element={<EventDetails />} />
        <Route path="/event-category" element={<EventCategory />} />
        <Route path="/order-summery" element={<OrderSummery />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/e-ticket" element={<Ticket />} />
        <Route path="/favorite" element={<Favorite />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/done" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/PaymentRespons" element={<PaymentResponse />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/faq" element={<Faq />} />
        <Route path=":title" element={<Pages />} />
        <Route path="/organizer-info" element={<Organizer />} />

      </Routes>

      {!Hidden && <Footer />}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
/* jshint ignore:end */
